/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { CompletePhoneVerificationReq } from '../_model/completePhoneVerificationReq';
import type { SendVerificationCodeReq } from '../_model/sendVerificationCodeReq';
import type { SuccessBodyCompletePhoneVerificationRes } from '../_model/successBodyCompletePhoneVerificationRes';
import type { SuccessBodyVerifyCodeRes } from '../_model/successBodyVerifyCodeRes';
import type { VerifyCodeReq } from '../_model/verifyCodeReq';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 발송된 인증번호를 검증합니다. 인증번호는 5분간 유효합니다.
 * @summary 휴대폰 인증번호 검증
 */
export const verifyCode = (
  verifyCodeReq: BodyType<VerifyCodeReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyVerifyCodeRes>(
    {
      url: `/users/phone/verify-code`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: verifyCodeReq,
      signal,
    },
    options,
  );
};

export const getVerifyCodeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyCode>>,
    TError,
    { data: BodyType<VerifyCodeReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyCode>>,
  TError,
  { data: BodyType<VerifyCodeReq> },
  TContext
> => {
  const mutationKey = ['verifyCode'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyCode>>,
    { data: BodyType<VerifyCodeReq> }
  > = props => {
    const { data } = props ?? {};

    return verifyCode(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyCode>>
>;
export type VerifyCodeMutationBody = BodyType<VerifyCodeReq>;
export type VerifyCodeMutationError = ErrorType<unknown>;

/**
 * @summary 휴대폰 인증번호 검증
 */
export const useVerifyCode = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verifyCode>>,
      TError,
      { data: BodyType<VerifyCodeReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verifyCode>>,
  TError,
  { data: BodyType<VerifyCodeReq> },
  TContext
> => {
  const mutationOptions = getVerifyCodeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 한국 유저에게 SMS 인증번호를 발송합니다. 30초 쿨다운, 하루 최대 5회 제한이 있습니다.
 * @summary 휴대폰 인증번호 발송
 */
export const sendVerificationCode = (
  sendVerificationCodeReq: BodyType<SendVerificationCodeReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<unknown>(
    {
      url: `/users/phone/send-code`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sendVerificationCodeReq,
      signal,
    },
    options,
  );
};

export const getSendVerificationCodeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendVerificationCode>>,
    TError,
    { data: BodyType<SendVerificationCodeReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendVerificationCode>>,
  TError,
  { data: BodyType<SendVerificationCodeReq> },
  TContext
> => {
  const mutationKey = ['sendVerificationCode'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendVerificationCode>>,
    { data: BodyType<SendVerificationCodeReq> }
  > = props => {
    const { data } = props ?? {};

    return sendVerificationCode(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendVerificationCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendVerificationCode>>
>;
export type SendVerificationCodeMutationBody =
  BodyType<SendVerificationCodeReq>;
export type SendVerificationCodeMutationError = ErrorType<unknown>;

/**
 * @summary 휴대폰 인증번호 발송
 */
export const useSendVerificationCode = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendVerificationCode>>,
      TError,
      { data: BodyType<SendVerificationCodeReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendVerificationCode>>,
  TError,
  { data: BodyType<SendVerificationCodeReq> },
  TContext
> => {
  const mutationOptions = getSendVerificationCodeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 
            인증 완료된 전화번호를 저장하고 마케팅 동의를 처리합니다.
            - 대상: KR 유저 중 TEACHER, NORMAL, COMPANY (학생 제외)
            - 마케팅 동의 (이메일, 전화) 자동 ON
            - 첫 인증 시 PRO 14일 이용권 지급 (재인증 시 미지급)
        
 * @summary 휴대폰 인증 완료
 */
export const completePhoneVerification = (
  completePhoneVerificationReq: BodyType<CompletePhoneVerificationReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyCompletePhoneVerificationRes>(
    {
      url: `/users/phone/complete`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: completePhoneVerificationReq,
      signal,
    },
    options,
  );
};

export const getCompletePhoneVerificationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completePhoneVerification>>,
    TError,
    { data: BodyType<CompletePhoneVerificationReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completePhoneVerification>>,
  TError,
  { data: BodyType<CompletePhoneVerificationReq> },
  TContext
> => {
  const mutationKey = ['completePhoneVerification'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completePhoneVerification>>,
    { data: BodyType<CompletePhoneVerificationReq> }
  > = props => {
    const { data } = props ?? {};

    return completePhoneVerification(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompletePhoneVerificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof completePhoneVerification>>
>;
export type CompletePhoneVerificationMutationBody =
  BodyType<CompletePhoneVerificationReq>;
export type CompletePhoneVerificationMutationError = ErrorType<unknown>;

/**
 * @summary 휴대폰 인증 완료
 */
export const useCompletePhoneVerification = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof completePhoneVerification>>,
      TError,
      { data: BodyType<CompletePhoneVerificationReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof completePhoneVerification>>,
  TError,
  { data: BodyType<CompletePhoneVerificationReq> },
  TContext
> => {
  const mutationOptions = getCompletePhoneVerificationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
